export const SET_AVATAR_LOADING = 'SET_AVATAR_LOADING';
export const SET_AVATAR_DATA = 'SET_AVATAR_DATA';
export const FORCE_BROADCAST = 'FORCE_BROADCAST';
